import Link from "next/link"
import { Routes, useParam } from "@blitzjs/next"
import React, { FC } from "react"
import FoSLogo from "src/app/core/components/FoSLogo"
import Redirect from "../../../core/components/Redirect"

type Props = {
  schoolSlug?: string
}

const SchoolLogo: FC<Props> = ({ schoolSlug: schoolSlugProp }) => {
  const schoolSlugParam = useParam("school", "string")
  const schoolSlug = schoolSlugProp ?? schoolSlugParam

  if (!schoolSlug) {
    return <Redirect url={Routes.Home()} />
  }

  return (
    <Link href={Routes.Home()} passHref legacyBehavior>
      <a style={{ display: "inline-flex" }}>
        <FoSLogo height={32} invert />
        {/*<img*/}
        {/*  src={`/schools/logos/${schoolSlug}.png`}*/}
        {/*  srcSet={`/schools/logos/${schoolSlug}@2x.png 2x`}*/}
        {/*  alt="School logo"*/}
        {/*/>*/}
      </a>
    </Link>
  )
}

export default SchoolLogo
